import { Pipe, PipeTransform } from '@angular/core';
import { buyerType } from '../../const/options';
import { CREATION_TYPE_CONST, Price } from '@shared-logic/prices';

@Pipe({
  name: 'isPriceOfCommodities',
})
export class FilterPriceByCommoditiesPipe implements PipeTransform {
  transform(priceList: Price[], identificator: string) {
    if (identificator == buyerType.ALL) return priceList;

    return priceList.filter((price) => isFromCommodities(price, identificator));
  }
}

@Pipe({
  name: 'isOrderOfCommodities',
})
export class FilterOrderByCommoditiesPipe implements PipeTransform {
  transform(orderList: any[], identificator: string) {
    if (identificator == buyerType.ALL) {
      return orderList;
    }

    let orderListToReturn: any[] = [];
    orderListToReturn = orderList.filter((order) =>
      isFromCommodities(order.price, identificator)
    );

    return orderListToReturn;
  }
}

export function isFromCommodities(price: Price, identificator: string) {
  // Si es "Ver todos", mostrar todo
  if (identificator == buyerType.ALL) {
    return true;
  }

  // Si es Cramdown, filtrar SOLO por creationType === 2
  if (identificator == buyerType.CRAMDOWN) {
    return price.creationType === CREATION_TYPE_CONST.CRAMDOWN;
  }

  // Para Commodities y Compradores, EXCLUIR los Cramdown (creationType === 2)
  // Primero verificamos que NO sea Cramdown
  if (price.creationType === CREATION_TYPE_CONST.CRAMDOWN) {
    return false;
  }

  // Luego aplicamos la lógica original para Commodities y Compradores
  // Si isPort == 1 → es Comprador
  // Si isPort == 0 → es Commodities
  return (price.observations.isPort == 1) == (identificator == buyerType.BUYER);
}
